import { useEffect, useRef, useState } from "react";

const STATUS_LABEL = {
  available: "",
  billed: "In bollettino",
  paid: "Pagato",
};

function HoursMonthCell({ monthKey, cell, onChange }) {
  const [editing, setEditing] = useState(false);
  const [draft, setDraft] = useState("");
  const inputRef = useRef(null);
  const locked = cell.status === "billed" || cell.status === "paid";
  const hasValue = cell.hours !== null && cell.hours !== undefined && cell.hours !== "";

  useEffect(() => {
    if (editing && inputRef.current) {
      inputRef.current.focus();
      inputRef.current.select();
    }
  }, [editing]);

  const displayHours = () => {
    if (!hasValue) {
      return "—";
    }
    return Number(cell.hours).toLocaleString("it-IT", {
      minimumFractionDigits: 0,
      maximumFractionDigits: 2,
    });
  };

  const startEdit = () => {
    if (locked) {
      return;
    }
    setDraft(hasValue ? String(cell.hours).replace(".", ",") : "");
    setEditing(true);
  };

  const commit = () => {
    const normalized = draft.trim().replace(",", ".");
    if (normalized === "") {
      onChange(monthKey, { ...cell, hours: null, status: "available" });
    } else {
      const value = Number(normalized);
      if (Number.isNaN(value) || value < 0) {
        setEditing(false);
        return;
      }
      onChange(monthKey, {
        ...cell,
        hours: Math.round(value * 100) / 100,
        status: "available",
      });
    }
    setEditing(false);
  };

  const cancel = () => {
    setEditing(false);
    setDraft("");
  };

  const onKeyDown = (event) => {
    if (event.key === "Enter") {
      event.preventDefault();
      commit();
    }
    if (event.key === "Escape") {
      event.preventDefault();
      cancel();
    }
  };

  if (editing) {
    return (
      <td className="hours-month-cell is-editing">
        <input
          ref={inputRef}
          className="hours-month-input"
          type="text"
          inputMode="decimal"
          aria-label={`Ore ${monthKey}`}
          value={draft}
          onChange={(event) => setDraft(event.target.value)}
          onBlur={commit}
          onKeyDown={onKeyDown}
        />
      </td>
    );
  }

  return (
    <td
      className={`hours-month-cell is-${cell.status}${locked ? " is-locked" : " is-editable"}`}
      onClick={startEdit}
      title={
        locked
          ? `${STATUS_LABEL[cell.status]}. Annullare il bollettino per modificare.`
          : "Clicca per modificare le ore"
      }
    >
      <span className="hours-month-value">{displayHours()}</span>
      {locked && (
        <span className={`hours-month-badge is-${cell.status}`}>
          {STATUS_LABEL[cell.status]}
        </span>
      )}
    </td>
  );
}

export default HoursMonthCell;
